import './index.scss'
import {memo} from 'react'
import {Link} from 'react-router-dom'
import classNames from 'classnames'
import {ArrowRightIcon} from '../../../icons'
import {colors} from '../../../utils/colors'
import {useSelector} from 'react-redux'

const Breadcrumb = ({data = []}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    return (
        <div className={classNames('breadcrumbs', {
            dark: isDarkMode
        })}>
            {data.map(item => (
                <>
                    {typeof item === 'string' || item?.props ? <span>{item}</span> : (
                        <span className={classNames({
                            'd-flex align-items-center gap-half': true
                        })}>
                            <span className="d-flex"><ArrowRightIcon color={colors.colorSlateBlue}/></span> <Link
                                className="link"
                                to={item.path}>{item.title}</Link>
                        </span>
                    )}
                </>
            ))}
        </div>
    )
}

export default memo(Breadcrumb)
